/* eslint-disable @typescript-eslint/naming-convention */
export enum FinancialType {
  REVENUE = 'REVENUE',
  COST = 'COST',
  PROFIT = 'PROFIT'
}

export enum ValuePerType {
  COST_PER_KM = 'COST_PER_KM',
  COST_PER_SHIPMENT = 'COST_PER_SHIPMENT',
  REVENUE_PER_KM = 'REVENUE_PER_KM',
  REVENUE_PER_SHIPMENT = 'REVENUE_PER_SHIPMENT',
  PROFIT_PER_KM = 'PROFIT_PER_KM',
  PROFIT_PER_SHIPMENT = 'PROFIT_PER_SHIPMENT'
}